// Module
var code = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16\" xml:space=\"preserve\"> <path style=\"fill:#ffda44\" d=\"M345.043,15.923C317.31,5.633,287.314,0,256,0s-61.31,5.633-89.043,15.923L144.696,256\r\n\tl22.261,240.077C194.69,506.368,224.686,512,256,512s61.31-5.632,89.043-15.923L367.304,256L345.043,15.923z\"/> <path style=\"fill:#d80027\" d=\"M512,256c0-110.07-69.472-203.906-166.957-240.076v480.155C442.528,459.906,512,366.072,512,256z\"/> <path d=\"M0,256c0,110.072,69.472,203.906,166.957,240.078V15.924C69.472,52.094,0,145.93,0,256z\"/>SZ </svg> ";
// Exports
module.exports = code;


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader/dist/cjs.js!./src/assets/icons/icon-belgium.svg
// module id = zgge
// module chunks = 34